var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"width-100-pr",domProps:{"innerHTML":_vm._s(_vm.block.data.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }